import React, { useEffect, useState } from "react";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import PerfectScrollbar from "react-perfect-scrollbar";
import Footer from "../shared/Footer";
import InputTopLabel from "../shared/InputTopLabel";
import TextAreaTopLabel from "../shared/TextAreaTopLabel";
import Input from "../shared/Input";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { FiSave } from "react-icons/fi";
import { useLocation } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SettingSeoForm = () => {

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  // “general” tablosundaki alanlar:
  const [title, setTitle] = useState("");         
  const [description, setDescription] = useState("");
  const [author, setAuthor] = useState("");
  const [keywords, setKeywords] = useState("");
const location = useLocation();
const params = new URLSearchParams(location.search);
const lang = params.get("lang") || "tr";
  // İlk render’da verileri çek
useEffect(() => {
    fetchGeneralData();
  }, [lang]);

  

  const fetchGeneralData = async () => {
    try {
      const resp = await axios.get(
  `${BASE_URL}/api/general?lang=${lang}`
);
      console.log("Gelen Data:", resp.data);

      // Metinsel alanlar
      setTitle(resp.data.title || "");
      setDescription(resp.data.description || "");
      setAuthor(resp.data.author || "");
      setKeywords(resp.data.keywords || "");

    } catch (err) {
      console.error("Veri çekme hatası:", err);
      toast.error(getText("ERROR_FETCH_GENERAL_SETTINGS"));
    }
  };

  // Kayıt butonuna basınca
  const handleSave = async () => {
    try {
      await axios.put(`${BASE_URL}/api/general/update`, {
        lang: lang,
        title,
        description,
        author,
        keywords,
      });
      toast.success(getText("SUCCESS_SEO_UPDATED"));
 
    } catch (error) {
      console.error("SEO Bilgileri kaydedilemedi:", error);
      toast.error(getText("ERROR_SAVE_FAILED"));
    }
  };

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <PageHeaderSetting />
        <div className="content-area-body">
          <div className="card mb-0">
            <div className="card-body">
              
            {/* Title */}
            <div className="mb-3">
              <label className="form-label fw-bold">{getText("MENU_SETTINGS_TITLE")}</label>
              <input
                type="text"
                className="form-control"
                placeholder={getText("PLACEHOLDER_TITLE")}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            {/* Description */}
            <div className="mb-3">
              <label className="form-label fw-bold"> {getText("MENU_SETTINGS_DESCRIPTION")}</label>
              <textarea
                className="form-control"
                rows="3"
                placeholder={getText("PLACEHOLDER_DESCRIPTION")}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            {/* Author */}
            <div className="mb-3">
              <label className="form-label fw-bold">{getText("MENU_SETTINGS_AUTHOR")}</label>
              <input
                type="text"
                className="form-control"
                placeholder={getText("PLACEHOLDER_AUTHOR")}
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
              />
            </div>

            {/* Keywords */}
            <div className="mb-3">
              <label className="form-label fw-bold">{getText("MENU_SETTINGS_KEYWORDS")}</label>
              <textarea
                className="form-control"
                rows="3"
                placeholder={getText("PLACEHOLDER_KEYWORDS")}
                value={keywords}
                onChange={(e) => setKeywords(e.target.value)}
              />
            </div>

              <div className="d-flex justify-content-center mt-4">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSave}
                >
                  <FiSave className="me-2" />
                  {getText("SAVE_BTN")}
                </button>
              </div>

            </div>
          </div>
        </div>
        
      </PerfectScrollbar>
    </div>
  );
};

export default SettingSeoForm;
